import type { Achievement } from '@/types/EntityTypes';
import type { GameState } from '@/types';

export class AchievementEntity implements Achievement {
  public id: string;
  public name: string;
  public condition: (state: GameState) => boolean;
  public description: string;

  constructor({
    id,
    name,
    condition,
    description = ''
  }: {
    id: string;
    name: string;
    condition: (state: GameState) => boolean;
    description?: string;
  }) {
    this.id = id;
    this.name = name;
    this.condition = condition;
    this.description = description;
  }

  isUnlocked(state: GameState): boolean {
    return this.condition && typeof this.condition === 'function' && this.condition(state);
  }

  isEarned(state: { achievements: string[] }): boolean {
    return state.achievements && state.achievements.includes(this.id);
  }

  getDisplayText(): string {
    return `🏆 ${this.name}`;
  }

  /**
   * Static method to filter new achievements based on game state
   */
  static getNewAchievements(achievements: AchievementEntity[], state: GameState): AchievementEntity[] {
    return achievements.filter(achievement => 
      achievement.isUnlocked(state) && !achievement.isEarned(state)
    );
  }
} 